<template>
	<div :class="{ 'side-menu-container--opened': sideMenuOpened, 'side-menu-container--closed': !sideMenuOpened }">
		<transition name="fade">
			<div class="side-menu" :class="{ 'side-menu--opened': sideMenuOpened, 'side-menu--closed': !sideMenuOpened }">
			<a class="side-menu__header flex">
				<!-- <img :src="sideMenuOpened ? require('@/assets/img/logo-small-text.svg') : require('@/assets/img/logo-small.svg')" alt="uni logo"> -->
			</a>
			<a
				class="side-menu-toggle"
				:class="{ 'side-menu-toggle--opened': !sideMenuOpened }"
				href=""
				@click.prevent="sideMenuOpened = !sideMenuOpened"
			/>

			<div class="side-menu__opened-content" v-show="sideMenuOpened">
				<div class="side-menu__student-ava">
					<img v-if="userInfo && userInfo.logoUrl" class="side-menu__student-image" :src="apiImg + userInfo.logoUrl">
                    <img v-else alt="Profile photo" contain src="../../assets/img/defaultProfileImage.png" class="tr-scale" />
				</div>
				<div class="side-menu__student-name" >
					<span v-if="userInfo">Dr. Akker</span>
				</div>

				<ul class="side-menu__nav-bar" >
                    <li
                        v-for="(item, key) in getSections"
                        :key="'A' + key"
                        class="side-menu__nav-item side-menu__nav-item--stats"
                        :class="{ 'side-menu__nav-item--active': $route.path == item.path }"
                        @click.prevent="goRoute(item)"
                    >
                        <img svg-inline :src="require(`../../assets/img/icons/${item.icon}.svg`)" />
                        <p>{{ item.engName }}</p>
                    </li>

                    <!-- <li class="side-menu__nav-item side-menu__nav-item--stats" @click="openInfo = true">
                        <img svg-inline :src="require('../../assets/img/icons/Information.svg')" />
                        <p>Помощь</p>
                    </li> -->

				</ul>
				<a class="side-menu__exit" @click.prevent="logoutFunc">
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M18 0.9C18 0.402944 17.5971 0 17.1 0H9.00374C8.50668 0 8.10374 0.402944 8.10374 0.9C8.10374 1.39706 8.50668 1.8 9.00374 1.8H16.2V16.2H9C8.50294 16.2 8.1 16.6029 8.1 17.1C8.1 17.5971 8.50294 18 9 18H17.1C17.5971 18 18 17.5971 18 17.1V0.9Z" fill="white"/>
						<path d="M5.5864 4.3136C5.23492 3.96213 4.66508 3.96213 4.3136 4.3136L0.312771 8.31444C0.12125 8.47948 0 8.72382 0 8.99648L1.90735e-06 8.99814C-0.000473022 9.22909 0.0873947 9.46019 0.263603 9.6364L4.3136 13.6864C4.66508 14.0379 5.23492 14.0379 5.5864 13.6864C5.93787 13.3349 5.93787 12.7651 5.5864 12.4136L3.06928 9.89648H12.6C13.0971 9.89648 13.5 9.49354 13.5 8.99648C13.5 8.49943 13.0971 8.09648 12.6 8.09648H3.07631L5.5864 5.5864C5.93787 5.23492 5.93787 4.66508 5.5864 4.3136Z" fill="white"/>
					</svg>
					Log out
				</a>
			</div>

			<div class="side-menu__closed-content" v-show="!sideMenuOpened">
				<div class="side-menu__student-ava">
					<img v-if="userInfo && userInfo.logoUrl" class="side-menu__student-image" :src="apiImg + userInfo.logoUrl">
                    <img v-else alt="Profile photo" contain src="../../assets/img/defaultProfileImage.png" class="tr-scale" />
				</div>
				<ul class="side-menu__nav-bar">
                    <li
                        v-for="(item, key) in getSections"
                        :key="'A' + key"
                        class="side-menu__nav-item side-menu__nav-item--stats"
                        :class="{ 'side-menu__nav-item--active': $route.path == item.path }"
                        @click.prevent="goRoute(item)"
                    >
                        <img svg-inline :src="require(`../../assets/img/icons/${item.icon}.svg`)" />
                    </li>

                    <!-- <li class="side-menu__nav-item side-menu__nav-item--stats" @click="openInfo = true">
                        <img svg-inline :src="require('../../assets/img/icons/Information.svg')" />
                    </li> -->
				</ul>
				<a class="side-menu__exit" @click.prevent="dialog = true">
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M18 0.9C18 0.402944 17.5971 0 17.1 0H9.00374C8.50668 0 8.10374 0.402944 8.10374 0.9C8.10374 1.39706 8.50668 1.8 9.00374 1.8H16.2V16.2H9C8.50294 16.2 8.1 16.6029 8.1 17.1C8.1 17.5971 8.50294 18 9 18H17.1C17.5971 18 18 17.5971 18 17.1V0.9Z" fill="white"/>
						<path d="M5.5864 4.3136C5.23492 3.96213 4.66508 3.96213 4.3136 4.3136L0.312771 8.31444C0.12125 8.47948 0 8.72382 0 8.99648L1.90735e-06 8.99814C-0.000473022 9.22909 0.0873947 9.46019 0.263603 9.6364L4.3136 13.6864C4.66508 14.0379 5.23492 14.0379 5.5864 13.6864C5.93787 13.3349 5.93787 12.7651 5.5864 12.4136L3.06928 9.89648H12.6C13.0971 9.89648 13.5 9.49354 13.5 8.99648C13.5 8.49943 13.0971 8.09648 12.6 8.09648H3.07631L5.5864 5.5864C5.93787 5.23492 5.93787 4.66508 5.5864 4.3136Z" fill="white"/>
					</svg>
				</a>
			</div>

			<v-dialog v-model="openInfo" max-width="450" persistent >
				<v-card>
                    <v-toolbar dark color="#310539">
                        <v-toolbar-title style="color: #cc74ba">
                            Help
                        </v-toolbar-title>

                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn @click="openInfo = false" icon color="#cc74ba">
                                <img svg-inline :src="require('@/assets/img/icons/Close.svg')" />
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <p class="mt-4 text-subtitle-1">Служба технической поддержки:</p>
                        <p class="text-subtitle-1">qa2@nitrosbase.com</p>
                        <p class="text-subtitle-1">Часы работы: 09:00-18:00 (МСК)</p>
                        <p class="text-subtitle-1">
                            <a :href="`${calculateRole()}`" target="_blank">Руководство пользователя</a>
                        </p>
                    </v-card-text>
				</v-card>
			</v-dialog>

			<v-dialog
				v-model="dialog"
				max-width="410"
				persistent
			>
				<v-card>
				<v-card-title class="text-h5">
					Are you sure you want to log out
				</v-card-title>

				<v-card-actions>
					<div class="text-center" style="width:100%">
					<v-btn
					color="green darken-1"
					text
					@click="dialog = false"
					>
					No
					</v-btn>

					<v-btn
					color="green darken-1"
					text
					@click="logoutFunc"
					>
					Yes
					</v-btn>
					</div>
				</v-card-actions>
				</v-card>
			</v-dialog>

			</div>
		</transition>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import "./SideBar.scss";
export default {
	name: "SideBar",
	props: {
		mobile: Boolean
	},

	data() {
		return {
            sideMenuOpened: false,
            dialog: false,
            openInfo: false
		};
	},
	watch: {
		sideMenuOpened(val) {
			this.setSideMenu(val);
		}
	},
	methods: {
		...mapActions({
			getUserInfo: "user/getUserInfo",
			logout: "login/logout"
		}),
		...mapMutations({
			setSideMenu: 'setSideMenu'
		}),
		toggleMenu() {
			this.$emit('toggleMenu');
		},
		logoutFunc() {
			this.logout()
			.then(() => {
				this.$router.replace('/');
			})
		},
        goRoute(item) {
			console.log(item);
			if (item.path !== this.$route.path) {
                let query = {};

                for (let i = 0; i < this.getSections.length; i++) {
                    if(this.getSections[i].id === item.id) {
                        query = {
                            isDisabled: this.getSections[i].isDisabled,
                            placeholder: this.getSections[i].placeholder
                        }
                        break;
                    }
                }

				this.$router.push({ path: item.path, query: {...this.$route.query, ...query} });
			}
		},
        calculateRole() {
            if(this.userRoles === 'Admin') return 'https://apicdss.nitrosbase.com/Files/admin.pdf'
				else return 'https://apicdss.nitrosbase.com/Files/expert.pdf'
        }
	},
	computed: {
		...mapGetters({
			apiImg: "apiImg",
			userRoles: "login/userRoles",
			userInfo: "user/userInfo",
			apiUrl: 'apiUrl',
         getSections: 'user/getSections'
		}),
		viewDev() {
			return this.apiUrl === 'https://apicdssdev.nitrosbase.com/'
		}
	},
	created() {
        this.getUserInfo();
	}
};
</script>

<style scoped>
.tr-scale {
   transform: scale(1.5);
	border: 2px solid #E9F0FE;
	width: 100%;
}
</style>
